import { NextStepProvider } from "nextstepjs";
import { useSearchParams } from "react-router-dom";
import { v4 } from "uuid";

import { PlaygroundSession } from "../Playground";
import PlaygroundShimmer from "../Playground/PlaygroundShimmer";

import { PlaygroundTourProvider } from "@/components/Playground/tour/context";
import { TOUR_QUERY_PARAM } from "@/components/Playground/tour/hooks/useTourUrlParam";
import { PromptVersion } from "@/types";

const EditorContent = ({
  isLoading,
  promptVersion,
  instanceId,
  isSnippet = false,
}: {
  isLoading: boolean;
  promptVersion?: PromptVersion;
  instanceId: string;
  isSnippet?: boolean;
}) => {
  const [searchParams] = useSearchParams();
  const shouldStartTour = searchParams.has(TOUR_QUERY_PARAM);

  const editor =
    !isLoading && promptVersion ? (
      <PlaygroundSession
        key={promptVersion.id}
        editor
        isSnippet={isSnippet}
        instanceId={instanceId}
        selectedTemplateVersion={promptVersion}
        inputVariableSets={
          promptVersion.input_variable_sets?.map((setArray, index) => ({
            id: v4(),
            name: promptVersion.input_variable_set_names![index],
            variables: Array.isArray(setArray)
              ? setArray.map((set, varIndex) => ({
                  id: `var-${index}-${varIndex}`,
                  key: Object.keys(set)[0],
                  value: Object.values(set)[0] as string | object,
                }))
              : [],
          })) || []
        }
        blueprint={{
          prompt_template: promptVersion.prompt_template,
          provider_base_url_name: promptVersion.provider_base_url_name,
          commit_message: promptVersion.commit_message ?? undefined,
          metadata: promptVersion.metadata,
          report_id: promptVersion.report_id ?? undefined,
          provider_id: promptVersion.provider_id ?? undefined,
        }}
      />
    ) : (
      <PlaygroundShimmer />
    );

  return (
    <div className="flex h-full w-full min-w-0 flex-col">
      {shouldStartTour ? (
        <PlaygroundTourProvider>
          <NextStepProvider>{editor}</NextStepProvider>
        </PlaygroundTourProvider>
      ) : (
        editor
      )}
    </div>
  );
};

export default EditorContent;
